import { createStore } from 'vuex'


// Import modules
import auth from './modules/auth'
import app from './modules/app'

// Create store
export default createStore({
  modules: {
    auth,
    notifications:app
  },
  // Global state
  state: {
    stats: {
      deliverySlips: null
    }
  },
  // Mutations for global state
  mutations: {
    SET_STATS(state, stats) {
      state.stats = stats;
    },
    SET_DELIVERY_SLIP_STATS(state, deliverySlipStats) {
      state.stats.deliverySlips = deliverySlipStats;
    }
  },
  // Actions for global state

  actions: {
    async fetchDeliverySlipStats({ commit }) {
      try {
        const response = await this.$axios.get('/api/delivery-slips', { params: { per_page: 1 } });
        if (response.data.success) {
          commit('SET_DELIVERY_SLIP_STATS', { total: response.data.data.total });
        }
      } catch (error) {
        console.error('Error fetching delivery slip stats:', error);
      }
    },
    async fetchAllStats({ dispatch }) {
      dispatch('fetchDeliverySlipStats');
      // Add other stat fetching actions here as needed
    }
  },
  // Getters for global state
  getters: {
    stats: state => state.stats
  }
})
